import React, { useCallback, useState } from 'react';
import { View, FlatList, TouchableOpacity, ActivityIndicator } from 'react-native';
import { Text } from '../../../components/ui/AppText';
import { useInfiniteVideos, selectVideoItems } from '../hooks/useInfiniteVideos';
import { VIDEO_SORT, VIDEO_SECTION } from '../constants';
import ShortCard from './ShortCard';
import VideoComposerModal from './VideoComposerModal';
import VideoPlayerModal from './VideoPlayerModal';
import { styles } from './styles';

/**
 * "Atualizações" — os mais recentes E onde o usuário POSTA (YouTube ou vídeo
 * da galeria ≤1min, via VideoComposerModal). Sempre visível (mostra o "+ Vídeo").
 */
const ShortsSection = ({ colors, isAuthenticated, onRequireLogin }) => {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteVideos({ sort: VIDEO_SORT.RECENT, section: VIDEO_SECTION.UPDATES });
  const [composerVisible, setComposerVisible] = useState(false);
  const [playingIndex, setPlayingIndex] = useState(null);

  const videos = selectVideoItems(data);

  const handlePress = useCallback(
    (video) => {
      const idx = videos.findIndex((v) => v.id === video.id);
      setPlayingIndex(idx >= 0 ? idx : 0);
    },
    [videos]
  );

  const renderItem = useCallback(
    ({ item }) => <ShortCard video={item} onPress={handlePress} />,
    [handlePress]
  );

  const handleEnd = useCallback(() => {
    if (hasNextPage && !isFetchingNextPage) fetchNextPage();
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  const handleAdd = useCallback(() => {
    if (!isAuthenticated) { onRequireLogin?.(); return; }
    setComposerVisible(true);
  }, [isAuthenticated, onRequireLogin]);

  return (
    <View style={styles.section}>
      <View style={styles.sectionHeader}>
        <Text style={[styles.sectionTitle, { color: colors?.textPrimary }]}>Atualizações</Text>
        <TouchableOpacity style={styles.addButton} onPress={handleAdd} hitSlop={8}>
          <Text style={styles.addButtonText}>+ Vídeo</Text>
        </TouchableOpacity>
      </View>

      {isLoading ? (
        <ActivityIndicator style={styles.loader} />
      ) : videos.length === 0 ? (
        <Text style={styles.emptyText}>Ainda não há vídeos. Toque em "+ Vídeo" para compartilhar!</Text>
      ) : (
        <FlatList
          horizontal
          data={videos}
          keyExtractor={(item) => item.id}
          renderItem={renderItem}
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={styles.hScroll}
          onEndReached={handleEnd}
          onEndReachedThreshold={0.5}
        />
      )}

      <VideoComposerModal
        visible={composerVisible}
        onClose={() => setComposerVisible(false)}
        section={VIDEO_SECTION.UPDATES}
        allowGallery
      />
      <VideoPlayerModal
        // Seção é só de vídeo em pé (Shorts + galeria): player em proporção
        // vertical. Exclusivo daqui — "Mais relevantes" e o Perfil não recebem.
        vertical
        videos={videos}
        initialIndex={playingIndex ?? 0}
        visible={playingIndex != null}
        onClose={() => setPlayingIndex(null)}
        onEndReached={handleEnd}
      />
    </View>
  );
};

export default React.memo(ShortsSection);
